import React, { Component } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/NavBar";
import img from "../imgs/rain.jpg";
import CryForRainCover from "../imgs/cover.jpg";
import AmazonIcon from "../imgs/amazonIcon.png";
import BarnesAndNobelIcon from "../imgs/b&n.png";
import BeachPic from "../imgs/beach.jpg";
import StairsPic from "../imgs/stairs.jpg";
import BirthdayPic from "../imgs/birthday.jpg";

import { Link } from "react-router-dom";

const jumbotron = {
  backgroundImage: "url(" + img + ")",
  backgroundPosition: "center",
  backgroundRepeat: "repeat-y",
  backgroundSize: "cover",
  color: "white"
};

export default class Book extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="jumbotron jumbotron-fluid" style={jumbotron}>
          <div className="container fluid ">
            <div className="row" style={{ marginTop: ".5vh" }}>
              <div className="col-lg-12" style={{ float: "center" }}>
                <img
                  src={CryForRainCover}
                  style={{ height: "75vh", margin: "auto", display: "block" }}
                />

                <h1
                  className="display-3"
                  style={{
                    textAlign: "center",
                    fontSize: "4vh",
                    fontFamily: "lato",
                    marginTop: "6vh",
                    textShadow: "2px 2px 2px #000"
                  }}
                >
                  EXCLUSIVELY FROM THESE RETAILERS:
                </h1>

                <div className="row">
                  <div className="col-lg-6 align-self">
                    <Link className="nav-link" to="/amazon">
                      {
                        <img
                          src={AmazonIcon}
                          style={{ height: "16vh", marginTop: "10vh" }}
                        />
                      }
                    </Link>
                  </div>
                  <div className="col-lg-6 align-self">
                    <Link className="nav-link" to="/barnesAndNobel">
                      {
                        <img
                          src={BarnesAndNobelIcon}
                          style={{ height: "12vh", marginTop: "10vh" }}
                        />
                      }
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 align-self">
                    <h1
                      className="display-3"
                      style={{
                        textAlign: "center",
                        fontSize: "4vh",
                        fontFamily: "lato",
                        marginTop: "6vh",
                        textShadow: "2px 2px 2px #000"
                      }}
                    >
                      AMAZON, B&N, ELECTIO PUBLISHING, ITUNES{" "}
                    </h1>
                  </div>
                </div>

                <div
                  className="row"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    borderRadius: "15px",
                    marginTop: "8vh",
                    padding:'6vh'
                    
                  }}
                >
                  <div className="col-md-4 ">
                    <img
                      src={BeachPic}
                      style={{
                        height: "25vh",
                        margin: "auto",
                        display: "block"
                      }}
                    />
                  </div>

                  <div className="col-md-4 ">
                    <img
                      src={StairsPic}
                      style={{
                        height: "25vh",
                        margin: "auto",
                        display: "block"
                      }}
                    />
                  </div>
                  <div className="col-md-4 ">
                    <img
                      src={BirthdayPic}
                      style={{
                        height: "25vh",
                        margin: "auto",
                        display: "block"
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-lg-12"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.4)",
                      borderRadius: " 15px ",
                      marginTop: "8vh"
                    }}
                  >
                    <p
                      style={{
                        color: "white",
                        fontSize: "1.75vh",
                        textAlign: " justify",
                        textJustify: " inter-word",
                        margin: "1vh"
                      }}
                    >
                      Cry for Rain is the true story of soul-consuming, bitter, childhood battles
                within a young girl&#x2019;s home amidst Iran&#x2019;s political and religious
                upheavals. As a Christian minority growing up in Tehran, Iran, Ariana and
                her siblings faced harsh physical and emotional abuse from their unstable
                mother. On the other hand, her love for her papa leaves a yearning for
                his protection and next return from his trips as a truck driver. She holds
                onto hope, suffering through a bitter childhood, the loss of friends and
                family during the revolution, the regime change to an Islamic government,
                and a city embattled with Iraq. But most of all, Ariana struggles to survive
                her mother&#x2019;s cruelty. Petrosian penned this memoir as an encouragement
                to those who have experienced abuse and hardship, to let them know all
                hope is not lost, and choices do exist. Tangible and realistic, it shows
                us what it was like growing up in Iran, being an Armenian Christian within
                an Islamic government, and never having sanctuary or feeling safe&#x2026;
                anywhere. There are few true stories of Christians in Iran, much less one
                that shows a psychotic mother, a father in denial, children brutally abused
                and never protected by family or social services of any type, and how fleeing
                as a refugee to Greece, and then on to the U.S., saved her and her siblings.
                But most astonishing is the fact that she forgave her mother and is now
                caring for her in the Houston area &#x2014; exactly as Christ would have
                us do.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
